import React from "react";

const SvgBigGlare = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="BigGlare_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#BigGlare_svg__a)">
      <path
        d="M37.06 34.84c-10.75 7.6-14.47 23.12-15.34 35.29-.17 2.41 3.58 2.4 3.75 0 .77-10.78 4.45-25.64 13.45-32 2-1.38.08-4.63-1.89-3.24l.03-.05z"
        fill="#1D1D1B"
      />
    </g>
  </svg>
);

export default SvgBigGlare;